import { combineReducers } from "redux";
import entityService from "../reducers/Entity"

const rootReducer = combineReducers({
  entityService
});

export default rootReducer;
